import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ArrowRight } from '@phosphor-icons/react';
import SEO from '../components/SEO';
import { LOGO_URL } from '../lib/brand';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setMessage('If an account exists with this email, you will receive a password reset link.');
    } catch (e) { setMessage('Something went wrong. Please try again.'); }
    finally { setLoading(false); }
  };

  return (
    <>
      <SEO title="Reset Password" description="Reset your Beyond Ball India password." path="/forgot-password" />
      <div className="min-h-screen flex items-center justify-center px-4 py-24 court-pattern">
        <div className="max-w-md w-full">
          <div className="text-center mb-8 animate-fade-up">
            <Link to="/" className="inline-block mb-6">
              <img src={LOGO_URL} alt="Beyond Ball India" className="h-14 w-14 rounded-full object-contain mx-auto" />
            </Link>
            <h1 className="text-3xl font-bold tracking-tight text-gray-900 mb-2" data-testid="forgot-password-title">Reset password</h1>
            <p className="text-gray-600">Enter your email to receive a reset link.</p>
          </div>

          <div className="bg-white border border-gray-200 rounded-2xl p-8 shadow-sm animate-fade-up delay-100">
            {message && (
              <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 mb-5 text-sm rounded-xl" data-testid="forgot-message">{message}</div>
            )}
            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1.5">Email</label>
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email-input"
                  className="w-full bg-gray-50 border border-gray-200 focus:bg-white focus:border-[#F97316] focus:ring-2 focus:ring-orange-100 rounded-xl px-4 py-3 text-sm outline-none transition-all" />
              </div>
              <button type="submit" disabled={loading} className="btn-primary w-full px-5 py-3 rounded-xl text-sm font-semibold flex items-center justify-center gap-2 disabled:opacity-50" data-testid="forgot-submit-btn">
                {loading ? 'Sending...' : 'Send reset link'} {!loading && <ArrowRight size={16} weight="bold" />}
              </button>
            </form>
            <div className="mt-6 text-center">
              <Link to="/login" className="text-sm text-[#F97316] hover:text-orange-700 font-semibold" data-testid="back-to-login-link">Back to login</Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
